// ReferenceSection.tsx
import React, { useState, useEffect } from 'react';
import { FreshIcon, Cryopreserve, PoolIcon } from "../../../assets/CommonSvg"
import { Button,Tooltip } from '@mui/material';
import {  actionButtons} from '../../../../bmr/constants/constant'
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentCycle } from "../../../slices/common"
import { setSubjectDataList } from "../../../slices/help"
import { approveChangeRequest, rejectChangeRequest} from "../../../slices/manufacturer"
import { hasAuthority } from '../../../../utils/authorities'
import {selectV2VCycle } from "../../../slices/common";
import {getTooltipTextButton} from "../../../../utils/utils"
import BsModal from "../../common/BaseModal"
import TemplateForm from "./TemplateForm"
import RequestHistory from '../../../../bmr/pages/appointment-details/RequestHistory'
import bmrSubjectApi from '../../../../bmr/services/bmrSubjectService';

const ReferenceSection = ({ 
  className = "", 
  onUpdate = {}, 
  subject_id = '',
}) => {
  const dispatch = useDispatch();
  const V2VCycle = useSelector(selectV2VCycle);
  const LoginData = useSelector((state) => state.loginData);
  const bmr_permissions = LoginData?.bmr_permissions || []
  const [openModal, setOpenModal] = useState(false);
  const [SubjectData, setSubjectData] = useState({});
  const [slug, setSlug] = useState('');
  const [showManufectureButton, setShowManufectureButton] = useState(false)
  const currentCycle = useSelector(selectCurrentCycle)
  const [cycleList, setCycleList] = useState([])

    useEffect(() => {
      const data = V2VCycle?.filter((list) => list.cycle != currentCycle?.cycle && list.status != 2 && list.status != 0)?.map((it) => ({
        label: `${it?.cycle} (${it?.batch_no})`,
        value: it?.cycle
      }));
      setCycleList(data)
  },[V2VCycle])


  const references = [
    { label: "Fresh Apheresis", template: FreshIcon },
    { label: "Cryopreserved LSM", template: Cryopreserve },
    { label: "Pool Cycle", template: PoolIcon }
  ];

    const getSubjectDetails = async (id) => {
      try {
        const res = await bmrSubjectApi.getSubjectDetailsWithCryo(id, currentCycle?.feasibility_assessments_id);
        setSubjectData({id: subject_id, phase_id:res?.data?.phase_id,feasibility_id:currentCycle?.feasibility_assessments_id});
       dispatch(setSubjectDataList(res?.data))
      } catch (error) {
       console.log(error)
      }
    };

useEffect(() => {
  const data = currentCycle?.data?.find((it) => it?.slug == 'product-manufactured')
  if(data?.status == '1' || data?.status == '4' || data?.status == '5'){
    setShowManufectureButton(true)
  }
},[currentCycle])


useEffect(() => {
  if (subject_id) 
    getSubjectDetails(subject_id);
}, [subject_id]);

  // Handle modal opening
  const handleOpenModal = async(type) => {
    if(type == 'approve' || type == 'reject'){
       let res;
      if(currentCycle?.change_request){
         const payload = {
          feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
          product_manufacturing_stage_id: currentCycle?.product_manufacturing_id,        
          patient_id: subject_id,        
          qr_code_generated_id: currentCycle?.qr_code_generation_id,        
        };

       if(type == 'approve'){
       res = await dispatch(approveChangeRequest({data:payload})).unwrap();
       }else{
       res = await dispatch(rejectChangeRequest({data:payload})).unwrap();
       } 
      if(res?.status == 200 && onUpdate) {
         onUpdate()
      }
    }
    }else{
    setSlug(type);
    setOpenModal(true)
    }
  };

  // Handle modal closing
  const handleCloseModal = () => {
    setOpenModal(false);
    setSlug('')
  };

  return (
    <>
      <div className={`reference-section flex justify-between items-center pb-3 ${className}`}>
         <div className="flex items-center flex-wrap gap-2 min-w-0">
          <h4 className="text-sm font-semibold text-gray-700 whitespace-nowrap mb-2">Reference:</h4>
              <div className="flex gap-2 ml-2 mb-2 flex-wrap">
            {references.map((ref, index) => (
              <div key={index} className="flex items-center gap-2">
                {React.createElement(ref.template)}
                <span className="text-xs text-gray-600">{ref.label}</span>
                {index < references.length - 1 && (
                  <span className="text-gray-400 ml-2">|</span>
                )}
              </div>
            ))}
          </div>
        </div>
        {/* Action Buttons Section */}
        <div className='flex gap-3'>
          {showManufectureButton && actionButtons?.map((button, index) => {
            if((LoginData?.role_slug !== 'superadmin' || (LoginData?.role_slug == 'superadmin' && !currentCycle?.change_request)) && (button.type ==='approve' || button.type ==='reject')) return null;
             if(!hasAuthority(button?.authority, bmr_permissions) || (button.type === 'change-request' && LoginData?.role_slug == 'superadmin')) return null;
             const isDisabled = (button.type === 'change-request' && currentCycle?.change_request == 1) || (button.type === 'pool-cycles' && cycleList?.length < 1) || ((button.type === 'pool-cycles' || button.type === 'terminate') && currentCycle?.status == 2) || (button.type === 'change-request' && currentCycle?.status != 2) || currentCycle?.status == 0

            return (
            <Tooltip 
            title={getTooltipTextButton((button.type === 'change-request' && currentCycle?.change_request == 1), (button.type === 'pool-cycles' && cycleList?.length < 1), ((button.type === 'pool-cycles' || button.type === 'terminate') && currentCycle?.status == 2), (button.type === 'change-request' && currentCycle?.status != 2), currentCycle?.status == 0, button?.label)} 
            placement="top"
            key={'_tool_'+index}
          >
            <span  key={'_btn_'+index}>
            <Button
              key={button.type}
              type="button"
              onClick={() => !isDisabled && handleOpenModal(button?.type)}
              disabled={isDisabled}
              variant={button.variant}
              color={button.color}
              className={
                isDisabled 
                  ? ''                     // remove hover classes
                  : button.className || '' // apply only when enabled
              }
              sx={{
                textTransform: 'none',
                fontWeight: 500,
                borderRadius: '6px',

                // remove hover effect when disabled
                ...(isDisabled && {
                  '&:hover': {
                    backgroundColor: 'inherit !important',
                    color: 'inherit !important',
                  }
                }),

                // custom hover only when enabled
                ...(!isDisabled && button.color === 'error' && {
                  '&:hover': {
                    backgroundColor: '#009966',
                  }
                })
              }}
            >
              {button.label}
            </Button>
            </span></Tooltip>
          );
         })}
         {hasAuthority(['start-manufacturing','manufacturing-approve'], bmr_permissions) && <RequestHistory SubjectData={SubjectData} />}
        </div>
      </div>
      {openModal  && (
          <BsModal fullWidth={true} open={!!openModal} size='sm' onClose={handleCloseModal} title={slug === 'pool-cycles' ? 'Pool Cycles' : slug === 'terminate' ? 'Terminate Cycle' : 'Change Request'}>
                <TemplateForm cycleList={cycleList}  slug={slug} onUpdate={onUpdate} subject_id={subject_id} handleCloseModal={handleCloseModal}/>
              </BsModal>
      )}
    </>
  );
};

export default ReferenceSection;